export const PATIENT_CSRF_TOKEN = "patient_csrf_token"
export const PATIENT_ACCOUNT = "patient_account"
export const PATIENT_EXPIRES = "patient_expires"
export const USER = "user"
export const PORTAL_CSRF_TOKEN = "portal_csrf_token"
export const PORTAL_EXPIRES = "portal_expires"
export const PORTAL_POSTPONED_ACCESS_RIGHTS = "portal_postponed_access_rights"
